import React from 'react';
import { CreateForm, FormTemplateProps } from 'framework/form';
import { BaseTimelineItemFormLayout } from 'framework/ui/timeline';
import VendorNoteForm from '../shared/form/VendorNoteForm';
import useVendorNoteService from '../useVendorNoteService';

interface CreateNoteFormProps extends FormTemplateProps {
  onCancel: () => void;
}

const CreateVendorNoteForm = ({ submitFormFunc, onCancel, ...props }: CreateNoteFormProps) => {
  const { getValidationSchema } = useVendorNoteService();

  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getValidationSchema} {...props}>
      <BaseTimelineItemFormLayout isCreateForm onCancel={onCancel}>
        <VendorNoteForm />
      </BaseTimelineItemFormLayout>
    </CreateForm>
  );
};

export default CreateVendorNoteForm;
